import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { DtoClaimRakurakuHistorysGetReq } from "./abst/DtoClaimRakurakuHistorysGetReq";
import { DtoApiPager } from "./abst/DtoApiPager";

export class DtoClaimRakurakuHistorysGetReqImple extends DtoClaimRakurakuHistorysGetReq {
  public pager = new DtoApiPager();

  public IsValidImple(chkPager: boolean): string[] {
    let res: string[] = new Array();
    //ページャー用入力値チェック
    if (chkPager) {
      this.pager.IsValid4Pager(res);
    } else {
      res = res.concat(super.IsValid());
    }

    return res;
  }
}
